import { createTheme } from "@mui/material/styles";

/**
 * MUI theme for OptionEngine.
 *
 * MUI's default elevation ramp is a flat grey blur that reads as fog on a dark
 * background, so every shadow below is replaced with a contact + ambient pair
 * matching the --e1/--e2/--e3 ramp in styles/global.css.
 */
const contact = "0 1px 2px rgba(0,0,0,.5)";

export const theme = createTheme({
  palette: {
    mode: "dark",
    background: { default: "#0a0e14", paper: "#111722" },
    primary: { main: "#58a6ff", dark: "#1f6feb" },
    secondary: { main: "#bc8cff" },
    success: { main: "#00e676" },
    error: { main: "#ff5252" },
    warning: { main: "#ffd700" },
    text: { primary: "#f0f6fc", secondary: "#6b8296" },
    divider: "#1e2a3a",
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontSize: "1.9rem", fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontSize: "1.25rem", fontWeight: 800, letterSpacing: "-0.01em" },
    subtitle2: { fontSize: ".78rem", fontWeight: 700 },
    body2: { fontSize: ".84rem" },
    caption: {
      fontSize: ".68rem",
      letterSpacing: ".07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 9,
          boxShadow: `${contact}, inset 0 1px 0 rgba(255,255,255,.08)`,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: "#0d1520",
          border: "1px solid #2a3a4a",
          fontSize: ".74rem",
          boxShadow: "0 10px 28px rgba(0,0,0,.55)",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          background:
            "linear-gradient(168deg,#16202e 0%,#111722 46%,#0c131d 100%)",
          border: "1px solid #2a3a4a",
          boxShadow: "0 4px 8px rgba(0,0,0,.6), 0 22px 56px rgba(0,0,0,.55)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "#1e2a3a" },
      },
    },
  },
});

export default theme;
